import { FormGroup, FormControlLabel, Checkbox, Radio, Stack, Typography } from "@mui/material";
import { SubtypeState } from "../../../../types/actionModule/editor/subtypeEditorTypes";
import { ChecklistAnswerItem, ChecklistAnswerSubtypeResponse, ChecklistAnswerType } from "../../../../types/actionModule/subtypes/checklistAnswerSubtype";
import { Check, Close } from "@mui/icons-material";


interface Props {
    state: SubtypeState
}

export function ChecklistAnswerEditorPreview({ state }: Props) {
    const subtype = state.properties as Partial<ChecklistAnswerSubtypeResponse>;
    const value = (subtype.checklistItems ?? []) as ChecklistAnswerItem[];
    const answerType = subtype.checklistAnswerType as ChecklistAnswerType;

    return <FormGroup>
        {
            value.map((p, i) => <ItemPreview
                key={p.id ?? i}
                answerType={answerType}
                item={p}
                isChecked={i === 0} />)
        }
    </FormGroup>;
}

interface ItemPreviewProps {
    item: ChecklistAnswerItem;
    answerType: ChecklistAnswerType;
    isChecked: boolean;
}

function ItemPreview(props: ItemPreviewProps) {
    switch (props.answerType) {
        case "SingleChoice":
            return <FormControlLabel
                control={<Radio value={true} checked={props.isChecked} />}
                label={props.item.text} />
        case "MultipleChoice":
            return <FormControlLabel
                control={<Checkbox value={true} checked={props.isChecked} />}
                label={props.item.text} />
        case "MultipleChoiceWithDecline":
            return <Stack direction="row" sx={{alignItems: "center"}}>
                <Typography variant="body1">{props.item.text}</Typography>
                <div style={{ flex: 1 }}></div>
                <Close fontSize="small" />
                <Check fontSize="small" />
            </Stack>
    }
}